<template>
  <div class="home">
      <Vireed class="marginal" ></Vireed>
  </div>
</template>

<script>
import Vireed from '@/components/Vireed.vue';
export default {
  name: 'VireedPage',
  components: {
    Vireed
  }
}
</script>